/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { createUseStyles } from 'react-jss';
import { TextAdPlacementCardPreview, AdPlacementCardPreviewProps } from './text-ad-preview-card';
import { VerticalCarousel } from './carousel-container';

const useStyles = createUseStyles({
  adCustomMessageResponse: {
    fontSize: '18px',
    lineHeight: 1.43,
  },
  adCustomMessageAds: {
    marginTop: '15px',
  },
});

type AdsList = Array<AdPlacementCardPreviewProps>;

// eslint-disable-next-line @typescript-eslint/naming-convention
export type shownAdsProps = {
  shownAdsType: string,
  shownAds: AdsList,
  shownResponse: string,
};

export const AdsCustomMessage: React.FunctionComponent<shownAdsProps> = (props) => {
  const classes = useStyles();

  const { shownAdsType } = props;
  const { shownAds } = props;
  const { shownResponse } = props;

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: shownResponse }} className={classes.adCustomMessageResponse} />
      <div className={classes.adCustomMessageAds}>
        {shownAdsType === 'text'
          ? shownAds.map(
            (ad) => (
              <TextAdPlacementCardPreview
                {...ad}
              />
            ),
          )
          : (
            <VerticalCarousel
              shownAds={shownAds}
            />
          )}
      </div>
    </div>
  );
};
